import type { InstitutionalContext } from '../types/lifecycle';

function activeCount(context: InstitutionalContext): number {
  return context.contexts.filter((item) => item.trajectory_warning?.active
    || item.institutional_state_warning?.active
    || (item.direct_mechanism_paths?.length ?? 0) > 0).length;
}

export function InstitutionalWarningBadge({ context }: { context: InstitutionalContext | null | undefined }) {
  if (!context) return null;
  const systemic = context.systemic_convergence_warning?.active === true;
  const count = activeCount(context);
  if (!systemic && count === 0 && context.assessment_status !== 'assessment_unavailable') return null;
  const label = systemic
    ? 'Systémová konvergence'
    : count > 0
      ? context.contexts.some((item) => item.trajectory_warning?.active || item.institutional_state_warning?.active)
        ? 'Institucionální trajektorie'
        : 'Institucionální mechanismus'
      : 'Institucionální data neúplná';
  return <span className={`badge badge--institutional ${systemic ? 'badge--institutional-systemic' : ''}`}>{label}</span>;
}

export function InstitutionalWarningPanel({ context }: { context: InstitutionalContext | null | undefined }) {
  if (!context) return null;
  const active = context.contexts.filter((item) => item.trajectory_warning?.active
    || item.institutional_state_warning?.active
    || (item.direct_mechanism_paths?.length ?? 0) > 0);
  const systemic = context.systemic_convergence_warning;
  return (
    <section className="institutional-panel" aria-label="Institucionální trajektorie">
      <h3>Institucionální trajektorie</h3>
      <p>
        Toto je samostatné kontextové varování, nikoli automaticky finální alert. Finální alert stále vyžaduje
        přímou oporu v textu návrhu a realistický mechanismus.
      </p>
      {context.assessment_status === 'assessment_unavailable' && (
        <p className="institutional-panel__unavailable">Posouzení není dostupné; chybějící data nejsou potvrzením bezpečnosti.</p>
      )}
      {active.map((item) => (
        <div className="institutional-panel__item" key={`${item.institution_id}-${item.candidate_id}`}>
          <strong>{item.institution_id}</strong>
          <span>Pokrytí: {item.coverage_status === 'complete' ? 'úplné' : 'neúplné'}</span>
          {item.trajectory_warning?.active && <p>{item.trajectory_warning.reason}</p>}
          {item.institutional_state_warning?.active && <p>{item.institutional_state_warning.reason}</p>}
          {(item.direct_mechanism_paths?.length ?? 0) > 0 && <p>Text návrhu přímo uzavírá institucionální kontrolní cestu.</p>}
          {item.financial_autonomy?.direct_control && (
            <p><strong>Přímá finanční kontrola:</strong> {item.financial_autonomy.reason}</p>
          )}
        </div>
      ))}
      {systemic?.active && (
        <div className="institutional-panel__systemic">
          <strong>Systémová konvergence</strong>
          <p>{systemic.common_effect}</p>
        </div>
      )}
    </section>
  );
}
